<div
  class="activity-dot color-{{ color }}"
  [class.only-dot]="onlyDot"
  [class.has-link]="hasLink"
  [class.hide-bolt]="hideBolt"
  [class.has-new]="unreadCount"
  [class.no-border]="noBorder"
  *ngIf="unreadCount || !hideWhenEmpty"
>
  <app-svg src="/assets/icons/bolt.svg" class="bolt-icon" *ngIf="!hideBolt"></app-svg>
  <div class="text">
    <app-smooth-counter [value]="unreadCount" *ngIf="unreadCount < 100"></app-smooth-counter>
    <ng-container *ngIf="unreadCount >= 100">99+</ng-container>
  </div>
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="arrow-icon"
    *ngIf="hasLink"
  >
    <path d="M1 1.5L3.5 4L1 6.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</div>
